import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { useTranslation, Trans } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Popup from "../../../../common/Popup";
import PopupTrigger from '../../../../common/PopupTrigger';
import { TYPE, URL } from '../../../../../constant';
import { secondsToMinutes } from '../../../../../utils/utilityEtc';
import { diagnosisResultDelAPI } from '../../../../../api/diagnosisAPI';
import { useLoading, useUserInfo, useRequest, useLearningHistory, useAppBackBtn, useHackle } from '../../../../../hooks';
import PrecisionChart from './PrecisionChart';
import SpeedChart from './SpeedChart';
import Toast from "../../../../common/Toast";
import { useSelector } from 'react-redux';
import useAmplitude from '../../../../../hooks/useAmplitude';

function ResultInfo({ result, type }) {
  const history = useHistory();
  const { info } = useUserInfo();
  const { t } = useTranslation();
  const { setBackEventData } = useAppBackBtn();
  const { setLoading, clearLoading } = useLoading();
  const { setLearningHistoryInfo } = useLearningHistory();
  const { setAmplitudeLog } = useAmplitude();
  const deviceInfo = useSelector(state => state.deviceInfo);
  const [alert, setAlert] = useState(false);
  const [diagnosisResultDelAPICall, deleteResult] = useRequest((data) =>
    diagnosisResultDelAPI(data)
  )
  const { info : hackleInfo } = useHackle();
  const getHackle = hackleInfo?.LEARNING_RESULT;

  // 진단결과 초기화 
  useEffect(() => {
    if (!deleteResult) return;
    setLearningHistoryInfo({
      isCompleteAIDiagnosis: 'N', isCheckAIDiagnosisResult: 'N'
    });
    setAlert(true);
  }, [deleteResult]);

  const time = result?.explTime ? secondsToMinutes(result.explTime) : null;
  const locale = localStorage.getItem('locale');

  const learningBtn = () => {
    const { channelCode } = info;
  if (channelCode === TYPE.CHANNEL.WJTB
      || channelCode === TYPE.CHANNEL.GLOBAL01) {

      if(info.isPaymentCountry && !info.subScriptionPurchsYn) {
        if(info?.countryCd === TYPE.COUNTRY_CODE.KOREA) {
          // KR
          history.push(URL.PAYMENT.SUBSCRIBE);
        } else {
          // IN or PH
          history.push(URL.PAYMENT.SUBSCRIBE_NEW);
        }
      } else {
        history.push(URL.COURSE_LEARNING.GUIDE);
      }
      
    } else {
      history.push({
        pathname: URL.TOPIC_LEARNING
      })

    }
  }

  // 진단결과 초기화
  const aiDelete = () => {
    if (!info?.learnerId) return;
    setLoading({ isShowSpinner: true, spinnerType: '1' });
    diagnosisResultDelAPICall({ lrnMbrId: info.learnerId });
    clearLoading();

    setAmplitudeLog({ 
      eventCategory: 'test',
      eventName: '진단다시하기 클릭'
    })
  }

  const hideToast = () => {
    setAlert(false);

    if (info.channelCode === TYPE.CHANNEL.GLOBAL01) {
      setBackEventData({ pathname: URL.SELECT_LEARNING });
      history.push(URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DIAGNOSIS_GUIDE1);
    } else {
      history.push(URL.SELECT_LEARNING);
    }
    
  };

  return (
    <React.Fragment>
      <div className="centermiddleBox">
        <div className="centermiddleBox-item">
          <div className="lr-topBox lr-topBox-left">
            <h2 className="lr-tit-top">{t("LC_02_09_result.msg002")}</h2>
            <p className="lr-txt-top">
              <span className="ico ico-date" />
              {/* {t("LC_02_09_result.msg003")}   */}
              {
                t(
                  "LC_08_02-GM.msg002",
                  {
                    y: moment(result.dgnsBgnDt).format("YYYY"),
                    m: moment(result.dgnsBgnDt).format(locale === 'EN' ? 'MMMM' : 'MM'),
                    d: moment(result.dgnsBgnDt).format("DD"),
                  }
                )
              }
            </p>
          </div>
          {
            (!_.isNull(result?.cransrCt)
              && !_.isNull(result?.totQstCt)
              && !_.isNull(result?.dknowCo)
              && !_.isNull(time)
            ) && (
              <div className="lr-mySB lr-mySB-btm">
                <div className="lr-mySB-item item-solve">
                  <p className="lr-mySB-tit">{t("LC_02_09_result.msg004")}</p>
                  <span className="lr-mySB-txt">
                    {result.cransrCt}
                    <span className="small">/{result.totQstCt}</span>
                  </span>
                </div>
                <div className="lr-mySB-item item-wrong">
                  <p className="lr-mySB-tit">{t("LC_02_09_result.msg005")}</p>
                  <span className="lr-mySB-txt">{result.dknowCo}</span>
                </div>
                <div className="lr-mySB-item item-time">
                  <p className="lr-mySB-tit">{t("LC_02_09_result.msg006")}</p>
                  <span className="lr-mySB-txt">
                    {t("LC_08_02-GM.msg006", { m: time.min ? time.min : '0', s: time.sec ? time.sec : '00' })}
                  </span>
                </div>
              </div>
            )
          }
          {
            getHackle?.isShowHackle && 
              (
                <>
                  {/* B Type */}
                  { getHackle.variation === "B" &&
                    <div className="bgGra-txtBox">
                      <p className="tit_top">{t("LC_02_09_result.msg020")}</p>
                      <p className="tit_subject">{result.estPreStgNm}</p>
                      <p
                        className="txt"
                        dangerouslySetInnerHTML={{ __html: result.estPreStgDtl }}
                      />
                      {
                        type !== 'note' && (
                          <button
                            className="btn btn-blue"
                            onClick={learningBtn}
                          >
                            {t("LC_02_09_result.msg022")}
                          </button>
                        )
                      }
                    </div>
                  }
                </>
              )
          }
          {
            (result?.calclSpedCordn && result?.calclAcrcyCordn) && (
              <div className="charts-box">
                <div className="charts-item-wrap">
                  <PrecisionChart
                    result={result}
                  />
                </div>

                <div className="charts-item-wrap">
                  <div className="charts-label">
                    <p className="charts-tit orange">{t("LC_02_09_result.msg014")}</p>
                    <p className="charts-txt">{t("LC_02_09_result.msg015")}</p>
                  </div>
                  <div className="charts-item">
                    <p className="charts-yAxis">
                      {t("LC_02_09_result.msg024")}
                    </p>
                    <div className="charts-cont">
                      <SpeedChart result={result} />
                      {/* <img src="/static/images/tmp/graph_11.png" alt="" className="tmpImg" /> */}
                    </div>
                    <div className="moreInfoBox">
                      <p className="charts-xAxis right">{t("LC_02_09_result.msg017")}</p>
                    </div>
                  </div>
                  <div className="charts-btm moreUp">
                    <p className="txt">{t("LC_02_09_result.msg018")}</p>
                  </div>
                </div>
              </div>
            )
          }
          <div className="nowStepInfo">
            <p>
              <Trans>
                {t("LC_02_09_result.msg019", { message: result.estLastStgNm })}
              </Trans>
            </p>
          </div>

          {
            getHackle?.isShowHackle && 
              (
                <>
                  {/* A Type */}
                  { getHackle.variation === "A" &&
                    <div className="bgGra-txtBox">
                      <p className="tit_top">{t("LC_02_09_result.msg020")}</p>
                      <p className="tit_subject">{result.estPreStgNm}</p>
                      <p
                        className="txt"
                        dangerouslySetInnerHTML={{ __html: result.estPreStgDtl }}
                      />
                      {
                        type !== 'note' && (
                          <button
                            className="btn btn-blue"
                            onClick={learningBtn}
                          >
                            {t("LC_02_09_result.msg022")}
                          </button>
                        )
                      }
                    </div>
                  }
                </>
              )
          }
          {
            !getHackle?.isShowHackle && 
              <div className="bgGra-txtBox">
                <p className="tit_top">{t("LC_02_09_result.msg020")}</p>
                <p className="tit_subject">{result.estPreStgNm}</p>
                <p
                  className="txt"
                  dangerouslySetInnerHTML={{ __html: result.estPreStgDtl }}
                />
                {
                  type !== 'note' && (
                    <button
                      className="btn btn-blue"
                      onClick={learningBtn}
                    >
                      {t("LC_02_09_result.msg022")}
                    </button>
                  )
                }
              </div>
          }

          <div className="btnR-wrap">
            <div className="gray-txt-notice">
              <p>{t("LC_02_09_result.msg028")}</p>
              {deviceInfo.type === TYPE.DEVICE.PHONE && <br></br>}
              <p>{t("LC_02_09_result.msg029")}</p>
            </div>
            <div className="btnR-cell">
              { info.isPaymentCountry && !info.subScriptionPurchsYn ? 
                  <button
                    className="btn-onlyTxt-gray" 
                    onClick={() => history.push(info?.countryCd === TYPE.COUNTRY_CODE.KOREA ? URL.PAYMENT.SUBSCRIBE : URL.PAYMENT.SUBSCRIBE_NEW )}
                    >{t("LC_02_09_result.msg023")}</button>
                  :
                <PopupTrigger>
                  <button
                    className="btn-onlyTxt-gray"
                  >{t("LC_02_09_result.msg023")}</button>
                  <Popup onConfirm={aiDelete}>
                    <p
                      className="lc-alert_txt m-fw-normal"
                      dangerouslySetInnerHTML={{ __html: t("LC_02_09_lp.msg001") }}
                    />
                  </Popup>
                </PopupTrigger>
              }
            </div>
          </div>
        </div>
      </div>
      {alert && <PopupTrigger onClose={hideToast}><Toast>{t("LC_02_09_lp_toast.msg001")}</Toast></PopupTrigger>}
    </React.Fragment>
  );
}

export default ResultInfo;
